import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { of, switchMap, take } from 'rxjs';
import {
  AlertConfirmProperties,
  AlertService,
} from '../../services/alert.service';
import { IonColor } from '../../types/ion-color.type';

@Component({
  selector: 'shared-confirm-button',
  templateUrl: './confirm-button.component.html',
  styleUrls: ['./confirm-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConfirmButtonComponent {
  @Input() confirmButtonTextKey = '';
  @Input() color: IonColor = 'primary';
  @Input() isLoading = false;
  @Input() confirmProperties?: AlertConfirmProperties;

  @Input() isDisabled = false;

  @Output() readonly confirmOk = new EventEmitter<void>();
  @Output() readonly confirmCancel = new EventEmitter<void>();

  private readonly alertService = inject(AlertService);

  onConfirm(): void {
    if (!this.confirmProperties) {
      console.warn('Missing confirmProperties');
      return;
    }

    this.alertService
      .confirm(this.confirmProperties)
      .pipe(
        take(1),
        switchMap((isConfirmed) => {
          if (isConfirmed) {
            this.confirmOk.emit();
            return of(true);
          }
          this.confirmCancel.emit();
          return of(false);
        }),
      )
      .subscribe();
  }
}
